import { Stack, useMediaQuery } from '@mui/material';
import {
  forwardRef,
  ForwardRefExoticComponent,
  PropsWithChildren,
  PropsWithoutRef,
  RefAttributes,
} from 'react';

type FR<T, P> = ForwardRefExoticComponent<PropsWithoutRef<P> & RefAttributes<T>>;

type Align = 'left' | 'center' | 'right';

type Props = Required<PropsWithChildren> & {
  gap?: number;
  align?: Align;
};

const JUSTIFY_BY_ALIGN: Record<Align, 'flex-start' | 'center' | 'flex-end'> = {
  left: 'flex-start',
  center: 'center',
  right: 'flex-end',
};

export const group: FR<HTMLDivElement, Props> = forwardRef((props, ref) => {
  const { children, gap = 2, align } = props;
  const justifyContent = align ? JUSTIFY_BY_ALIGN[align] : 'space-evenly';

  return (
    <Stack
      ref={ref}
      direction="row"
      gap={gap}
      flexWrap="wrap"
      justifyContent={justifyContent}
      alignItems="center"
    >
      {children}
    </Stack>
  );
});

export const subgroup: FR<HTMLDivElement, Props> = forwardRef((props, ref) => {
  const { children, gap = 2, align } = props;

  const sm = useMediaQuery('(max-width:500px)');
  const justifyContent = align ? JUSTIFY_BY_ALIGN[align] : undefined;

  return (
    <Stack
      ref={ref}
      flex={1}
      direction="row"
      gap={gap}
      flexWrap={sm ? 'wrap' : 'nowrap'}
      justifyContent={justifyContent}
      alignItems="center"
    >
      {children}
    </Stack>
  );
});
